export const giftIconSize = 80
export const vipIconSize = 50
